export function wooAccordionScripts() {
    if (!document.getElementById('woo-accordion'))
        return;

    document.querySelectorAll('#woo-accordion').forEach(accordionWrapper => {
        let accordionButtons = accordionWrapper.getElementsByClassName(
            'accordion-button',
        );

        for (var i = 0; i < accordionButtons.length; i++) {
            let clickFlag = false;

            accordionButtons[i].addEventListener('click', function (event) {
                if (!clickFlag) {
                    var clickedButton = this;
                    var accordionId = clickedButton.dataset.accordion;
                    var accordionContent = document.getElementById(accordionId);

                    clickFlag = true;
                    accordionWrapper
                        .querySelectorAll('.accordion-button')
                        .forEach(button => {
                            if (clickedButton !== button) {
                                button.classList.add('closed');
                                document
                                    .getElementById(button.dataset.accordion)
                                    .classList.add('closed');
                            }
                        });

                    accordionContent.classList.toggle('closed');
                    clickedButton.classList.toggle('closed');

                    setTimeout(() => {
                        clickFlag = false;
                    }, 300);
                }
            });
        }
    });
}
